export const apiKeySecure = "48e48060-c718-46d1-92a6-d458c5e4a52a";
export const apiUrlSecure = "https://www.genialskillsservice.com:8739/api/";